import * as Primitives from '@coursera/cds-common';

export const createSvgIcon = Primitives.createSvgIcon;
